'use strict';

module.exports = require('./components');


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 246
 ** module chunks = 0
 **/